import PropTypes from 'prop-types'
import { Page, Container, ContentHeader, LoadingFeedback } from 'components'
import { PaymentServiceTemplateForm } from './components'

import { useFetch } from 'hooks'
import * as service from 'service'

const PaymentServiceTemplatesEdit = ({ match }) => {
  const {
    params: { paymentServiceTemplateId },
  } = match

  const { response, isLoading } = useFetch(
    service.dponet.paymentServiceTemplates.show,
    { paymentServiceTemplateId },
    [paymentServiceTemplateId],
  )

  return (
    <Page title="Edição de tipo de serviço">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader
          title="Edição"
          menu="Vendas"
          subtitle="Edição de tipo de serviço"
        />
        {!isLoading && (
          <PaymentServiceTemplateForm
            isEdit
            paymentServiceTemplate={response?.data?.paymentService}
          />
        )}
      </Container>
    </Page>
  )
}

PaymentServiceTemplatesEdit.propTypes = {
  match: PropTypes.object,
}

export default PaymentServiceTemplatesEdit
